module.exports = __webpack_public_path__ + "static/media/battery-three-quarters.0b96713a.svg";